function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
import Cnt from './components/Cnt.react';
import defaultConfig from './defaultConfig';
import IntlMessageFormat from 'intl-messageformat';
import dayjs from 'dayjs';
import React from 'react';
var NON_BREAKING_SPACE = '\xa0';
var handleErrorKey = function handleErrorKey(fn) {
  return function () {
    try {
      return fn.apply(void 0, arguments);
    } catch (error) {
      return "Error with key - ".concat(arguments.length <= 0 ? undefined : arguments[0]);
    }
  };
};
var Translator = /*#__PURE__*/
function () {
  function Translator(getState, config, engine) {
    _classCallCheck(this, Translator);
    this.cachedInstances = Object.create(null);
    this.getState = getState;
    this.config = _objectSpread({}, defaultConfig, config);
    this.engine = engine;
    this.msg = handleErrorKey(this.msg.bind(this));
    this.cnt = handleErrorKey(this.cnt.bind(this));
    this.defaultLocale = this.defaultLocale.bind(this);
    this.selectedLocale = this.selectedLocale.bind(this);
    this.messages = this.messages.bind(this);
    this.parseInteger = handleErrorKey(this.parseInteger.bind(this));
    this.formatDate = handleErrorKey(this.formatDate.bind(this));
    this.numberTo = handleErrorKey(this.numberTo.bind(this));
    this.numberToCurrency = handleErrorKey(this.numberToCurrency.bind(this));
    this.preciseNumberToCurrency = handleErrorKey(this.preciseNumberToCurrency.bind(this));
    this.numberToPercentage = handleErrorKey(this.numberToPercentage.bind(this));
    this.numberToRounded = handleErrorKey(this.numberToRounded.bind(this));
  }
  _createClass(Translator, [{
    key: "defaultLocale",
    value: function defaultLocale() {
      return this.getState()[this.config.reduxRoot].defaultLocale;
    }
  }, {
    key: "selectedLocale",
    value: function selectedLocale() {
      return this.getState()[this.config.reduxRoot].selectedLocale;
    }
  }, {
    key: "messages",
    value: function messages() {
      return this.getState()[this.config.reduxRoot].messages;
    } // msg('key.foo') => returns translation for key.foo
    // msg(['foo', 'bar']) => returns translation for foo if exists else bar
    // msg('foo.bar.foobar') => returns foo.bar.foobar else foo.foobar else foobar
    // msg('foo', options) => read documentation at:
    //                        http://formatjs.io/guides/message-syntax/
  }, {
    key: "msg",
    value: function msg(paths) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var pathsArray = [].concat(paths);
      var msg = this.__translateWithFallback(pathsArray, values);
      if (!msg && this.config.showMissingTranslations) return "!".concat(pathsArray.join(';'), "!");
      return msg;
    } // same attribs as for msg()
    // elements if html are wrapped in <span class="cnt" />
    // set this class globally and set its display to `inline` or `inline-block`
    // as default value
  }, {
    key: "cnt",
    value: function cnt(paths) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var msg = this.msg(paths, values);
      return React.createElement(Cnt, {
        content: msg
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date, options) {
      var overrideLocale = options && options.format ? options.format : false;
      var dateFormat = overrideLocale || this.__translateWithFallback('date.format');
      if (!date) return '';
      dayjs.locale(this.selectedLocale()); // format string optinos: https://github.com/iamkun/dayjs/blob/dev/docs/en/API-reference.md#format-formatstringwithtokens-string

      return dayjs(date).format(dateFormat.toString());
    }
  }, {
    key: "numberToCurrency",
    value: function numberToCurrency(number, options) {
      return this.numberTo('currency', number, options);
    }
  }, {
    key: "preciseNumberToCurrency",
    value: function preciseNumberToCurrency(number) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var precision = Math.round(number) === number ? 0 : options.preciseDecimalPlaces || 2;
      var decimalPlaces = Math.round(number) === number ? 0 : options.preciseDecimalPlaces || null;
      return this.numberTo('currency', number, _objectSpread({}, options, {
        precision: precision,
        decimalPlaces: decimalPlaces
      }));
    }
  }, {
    key: "numberToPercentage",
    value: function numberToPercentage(number, options) {
      return this.numberTo('percentage', number, options);
    }
  }, {
    key: "numberToRounded",
    value: function numberToRounded(number, options) {
      if (!(number || number === 0)) return '';
      var numberOptions = this.__getNumberOptions(['number', 'format'], options);
      var formattedNumber = this.__formatNumber(number, numberOptions);
      return formattedNumber !== 'NaN' ? formattedNumber : '';
    }
  }, {
    key: "numberTo",
    value: function numberTo(type, number) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!(number || number === 0)) return '';
      var allOptions = this.__getNumberOptions(['number', type, 'format'], options);
      var template = allOptions.format.toString();
      var formattedNumber = this.__formatNumber(number, allOptions);
      if (formattedNumber === 'NaN') return '';
      var result = template.replace('%n', formattedNumber).replace('%u', (allOptions.unit || '').toString());
      if (!options.wrap) {
        result = result.replace(' ', NON_BREAKING_SPACE);
      }
      return result;
    }
  }, {
    key: "parseInteger",
    value: function parseInteger(input) {
      var inputOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var defaultOptions = this.__translateWithFallback(['number', 'format']).toJS();
      var options = _objectSpread({}, defaultOptions, inputOptions);
      var result;
      if (typeof input === 'number' && input.toString() !== 'NaN') return input;
      if (typeof input !== 'string') return defaultVal;
      var isNegative = input.replace(/\s/g, '').search(/^-\d/) > -1;
      result = input.split(options.separator)[0].replace(/\D/g, '');
      result = isNegative ? "-".concat(result) : result;
      if (result === '') return defaultVal;
      return parseInt(result, 10);
    }
  }, {
    key: "__translateWithFallback",
    value: function __translateWithFallback(path) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.defaultLocale() !== this.selectedLocale()) {
        var translation = this.__translate(this.selectedLocale(), path, values);
        if (translation) return translation;
        return this.__translate(this.defaultLocale(), path, values);
      }
      return this.__translate(this.selectedLocale(), path, values);
    }
  }, {
    key: "__translate",
    value: function __translate(locale, path) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var paths = [].concat(path);
      while (paths.length) {
        var lookupPath = paths.shift();
        var translated = this.__translatePath(locale, lookupPath, values);
        if (!!translated) return translated;
      }
      return null;
    }
  }, {
    key: "__translatePath",
    value: function __translatePath(locale, pathString, values) {
      var pathParts = [locale].concat(pathString.split('.'));
      var message = this.messages().getIn(pathParts);
      if (!message) return null;
      if (this.engine) this.engine.rememberUsedTranslation(this.selectedLocale(), pathString.split('.'), message);
      if (values) {
        return this.__getCachedInstanceOf(message).format(values);
      }
      return message;
    }
  }, {
    key: "__getCachedInstanceOf",
    value: function __getCachedInstanceOf(message) {
      if (message in this.cachedInstances) return this.cachedInstances[message];
      this.cachedInstances[message] = new IntlMessageFormat(message, this.selectedLocale());
      return this.cachedInstances[message];
    }
  }, {
    key: "__roundNumber",
    value: function __roundNumber(number, options) {
      var decimal = options.preciseDecimalPlaces ? Math.pow(10, options.preciseDecimalPlaces) : Math.pow(10, options.precision);
      return Math.round(number * decimal) / decimal;
    } // add separator and delimiter and return string
  }, {
    key: "__formatNumber",
    value: function __formatNumber(number, options) {
      var numbers = this.__roundNumber(number, options);
      var decimalPlaces;
      if (options.decimalPlaces) {
        decimalPlaces = options.decimalPlaces;
      } else if (options.preciseDecimalPlaces) {
        decimalPlaces = Math.round(number) === number ? 0 : options.preciseDecimalPlaces;
      }
      if (typeof decimalPlaces === 'number') {
        numbers = numbers.toFixed(decimalPlaces);
      } else {
        numbers = numbers.toString();
      }
      numbers = numbers.split('.');
      numbers[0] = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, options.delimiter.toString());
      return numbers.join(options.separator.toString());
    }
  }, {
    key: "__getNumberOptions",
    value: function __getNumberOptions(path, options) {
      var defaultOptions = this.__translateWithFallback('number.format').toJS();
      var methodOptions = this.__translateWithFallback(path.join('.')).toJS();
      return _objectSpread({}, defaultOptions, methodOptions, options);
    }
  }]);
  return Translator;
}();
export { Translator as default };